<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0">
                <div class="float-right">
                    <a @click="refresh()" class="btn btn-sm btn-success" :title="trans.refresh" v-b-tooltip.hover><i class="fa fa-sync" :class="{'fa-spinner': loading}"></i></a>
                    <a @click="openSettings()" class="btn btn-sm btn-primary" :title="trans.modal.title" v-b-tooltip.hover><i class="fa fa-cog"></i></a>
                </div>

                <i class="fa fa-align-justify"></i> {{ trans.title }}
            </b-card-header>


            <b-card-body class="px-0 pt-0">

                <div class="loading-box" v-if="loading">
                    <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                </div>

                <div v-if="items.length == 0 && !loading" class="my-5 text-center text-secondary">
                    {{ trans.no_notifications }}
                </div>

                <b-list-group flush v-if="!loading">
                    <b-list-group-item v-for="(item, itemIndex) in items" :key="item.id" class="justify-content-between align-items-start" :class="{'read': !item.unread, 'expanded': (expandedId == item.id), 'expandable': item.items.length > 3}">
                        <div class="d-flex align-items-start">
                            <span class="status-info" :class="'text-'+item.css_type"><i class="fas fa-fw" :class="item.css_icon"></i></span>
                            <div class="m-0">
                                <h4>{{ getTitle(item) }}</h4>

                                <div class="d-inline-block" v-for="(subitem,subitemIndex) in item.items" :key="subitemIndex">
                                    <a :href="subitem.url" rel=opener target="_blank" class="mr-2 text-nowrap">
                                        <i class="fa fa-user"></i>
                                        {{ subitem.name }}<em v-if="subitem.date"> ({{ subitem.date }})</em><em v-if="subitem.number"> - {{ subitem.number }}</em><span v-if="subitemIndex < item.items.length-1">,</span>
                                    </a>
                                </div>

                                <a class="btn btn-xs expander" @click="toggleExpand(item)" v-b-tooltip.hover><i class="fa fa-fw fa-angle-down"></i></a>
                            </div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-card-body>
        </b-card>

        <notifications-settings
                :trans="trans.modal"
                :trans-types="trans.types"
                :settings="settings"
                :dynamic-fields-notifications="dynamicFieldsNotifications"
                :current-restaurant-id="currentRestaurantId"
        />
    </div>
</template>

<script>
    export default {
        props: {
            'trans': {
                type: Object
            },
            'settings': {
                type: Array
            },
            'dynamicFieldsNotifications': {
                type: Array
            },
            'currentRestaurantId': {
                type: Number
            }
        },

        data() {
            return {
                loading: true,
                loadingStateBtnsRead: [],
                items: [],
                expandedId: null
            };
        },

        created()
        {
            this.loadData();
        },

        methods: {

            openSettings()
            {
                this.$modal.show('modal-notifications-settings');
            },

            getTitle(item)
            {
                return (typeof this.trans.types[item.type] != "undefined" ? this.trans.types[item.type].message : item.items[0].dynamicFieldName);
            },

            loadData()
            {
                this.loading = true;
                var _this = this;

                axios.get("/dashboard/get-notifications").then(function (response) {
                    if(response && response.data)
                    {
                        _this.items = response.data;
                        _this.loading = false;
                    }
                }, function (error) {
                    _this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                    _this.loading = false;
                });
            },

            refresh()
            {
                this.loading = true;

                axios.post("/dashboard/notification-refresh").then((response) => {
                    this.loading = false;
                    this.loadData();

                }, (error) => {
                    this.loading = false;
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                });
            },

            toggleExpand(item)
            {
                this.expandedId = item.id;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/widgets/Notifications.vue